
<template>
  <div id="app">
     <div class="home">
    <!-- begin:: Page -->
    <div class="m-grid m-grid--hor m-grid--root m-page">
      <!-- BEGIN: Header -->
      <HeaderSide v-if="IsLogin"></HeaderSide>

      <!-- END: Header -->

      <!-- begin::Body -->
      <div
        class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body"
      >
        <!-- BEGIN: Left Aside -->
        <LeftMenu v-if="IsLogin"></LeftMenu>

        <!-- END: Left Aside -->
        <div class="m-grid__item m-grid__item--fluid m-wrapper">
          <!-- BEGIN: Subheader -->

          <!-- END: Subheader -->
          <router-view v-if="IsLogin"></router-view>
              <Login v-if="!IsLogin" @TheLogin::loginResult="handleLoginResult"/>

        </div>
      </div>

      <!-- end:: Body -->

      <!-- begin::Footer -->
      <FooterSide v-if="IsLogin"></FooterSide>

      <!-- end::Footer -->
    </div>
    <!-- end:: Page -->
    <!-- begin::Quick Sidebar -->
    <QuickSidebar v-if="IsLogin"></QuickSidebar>
    <!-- end::Quick Sidebar -->
    <!-- begin::Scroll Top -->
    <div id="m_scroll_top" class="m-scroll-top">
      <i class="la la-arrow-up"></i>
    </div>
    <!-- end::Scroll Top -->
  </div>
    <!-- <component v-bind:is="layout"></component> -->
          <loading :active.sync="this.$store.getters.isLoading" 
        :on-cancel="onCancel"
        :is-full-page="true" :loader="'dots'" :color="'#007bff'"></loading>
  </div>
</template>
	
<style lang="scss">

@import './vendors/tether/dist/css/tether.css';
@import './vendors/bootstrap-touchspin/dist/jquery.bootstrap-touchspin.css';
@import './vendors/bootstrap-switch/dist/css/bootstrap3/bootstrap-switch.css';
@import './vendors/bootstrap-select/dist/css/bootstrap-select.css';
@import './vendors/animate.css/animate.css';
@import './vendors/chartist/dist/chartist.min.css';
@import './vendors/sweetalert2/dist/sweetalert2.min.css';
@import './vendors/socicon/css/socicon.css';
@import './vendors/vendors/line-awesome/css/line-awesome.css';
@import './vendors/vendors/flaticon/css/flaticon.css';
@import './vendors/vendors/metronic/css/styles.css';
@import './vendors/vendors/fontawesome5/css/all.min.css';
@import './assets/demo/base/style.bundle.css';
@import './assets/vendors/custom/fullcalendar/fullcalendar.bundle.css';
@import './assets/spec/css/sk_style.css';
// @import './assets/vendors/custom/datatables/datatables.bundle.css';

.home {
  position: absolute;
  top: 0;
  width: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.spbtn{
    background-color: #3e7bf5; 
    border: none;
    border-radius:5px;
    font-weight: bold;
    color: white;
    padding: 10px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
  }
  .spbtn:hover{
    background-color: #5aa3ff;
  }

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<script>
import HeaderSide from "@/views/Header.vue";
import FooterSide from "@/views/Footer.vue";
import QuickSidebar from "@/views/QuickSidebar.vue";
import LeftMenu from "@/views/LeftMenu.vue";
import Login from "@/components/Login.vue"
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
 
    data() {
      return {
        login:localStorage.getItem("user-token")!=null,
         isLoading: false,
         fullPage: true
      }
    },
   computed: {
     IsLogin(){
       return this.login
     },
    
   },
    methods: {
        handleLoginResult({loginResult}) {
          this.login=localStorage.getItem("user-token")!=null
    },            onCancel() {
              console.log('User cancelled the loader.')
            }
    },


  components: {
    HeaderSide,
    FooterSide,
    QuickSidebar,
    LeftMenu,
    Login,
    Loading
  }
}
window.$ = require('./vendors/jquery');
window.jQuery = require('./vendors/jquery');
window.PerfectScrollbar  = require('./vendors/perfect-scrollbar/dist/perfect-scrollbar');
window.Popper  = require('./vendors/popper.js/dist/umd/popper.js');
window.Cookies  = require('./vendors/js-cookie/src/js.cookie');
window.bundle = require('./assets/demo/base/scripts.bundle');

// window.datatables.net=require('./assets/vendors/custom/datatables/datatables.bundle.js');
// window.login=require('./assets/snippets/custom/pages/user/login6.js');
</script>


